import React from 'react';
import { Colors, Fonts } from '../../../../../shared/theme';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20
  } as React.CSSProperties,
  mainBranchRegular14fakeBlack: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack,
    paddingTop: '8px',
    display: 'block'
  } as React.CSSProperties,
  branchNoRegular14fakeBlack: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack,
    paddingTop: '16px'
  } as React.CSSProperties,
  inputWidth150: {
    width: 140,
    height: 40,
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
  } as React.CSSProperties,
  branchNoBox: {
    paddingBottom: 0,
    paddingTop: '8px',
    paddingLeft: '25px',
  } as React.CSSProperties,
  remarkBox: {
    paddingBottom: '16px',
  } as React.CSSProperties,
  regular14fakeBlack: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack
  } as React.CSSProperties,
  light14fakeBlack: {
    fontFamily: Fonts.type.KanitLight,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack
  } as React.CSSProperties,
};
